import { render, staticRenderFns } from "./cupones.vue?vue&type=template&id=1775cbed&scoped=true"
import script from "./cupones.vue?vue&type=script&lang=js"
export * from "./cupones.vue?vue&type=script&lang=js"
import style0 from "./cupones.vue?vue&type=style&index=0&id=1775cbed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1775cbed",
  null
  
)

export default component.exports